import {Component, Input} from "@angular/core";
import {MicroFormService} from "./micro-form.service";
import {microFormProvider, MicroFormModel} from "./micro-form.model";

@Component({
  selector: "micro-input",
  templateUrl: "./micro-input.template.pug",
  providers: [microFormProvider(MicroInputComponent)],
  outputs: MicroFormModel.OUTPUTS,
  inputs: [...MicroFormModel.INPUTS, "type"],
})
export class MicroInputComponent extends MicroFormModel {
  private _type: string;

  @Input()
  set type(type: string) {
    this._type = type;
  }

  get type(): string {
    return this._type || "text";
  }

  @Input()
  public showAsHyperlink: boolean = false;

  @Input()
  public linkTarget: string = "";

  constructor(public microFormService: MicroFormService) {
    super(microFormService);
  }
}
